'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.AuthBearerMiddleware = AuthBearerMiddleware;

var _effects = require('redux-saga/effects');

function AuthBearerMiddleware(selector) {
    return function* internal(_ref, next) {
        let request = _ref.request;

        let token = yield (0, _effects.select)(selector);
        if (token) {
            request.headers.authorization = 'Bearer ' + token;
        }
        yield* next();
    };
}
//# sourceMappingURL=AuthBearerMiddleware.js.map


// WEBPACK FOOTER //
// ./node_modules/redux-saga-resources/node/middlewares/AuthBearerMiddleware.js